<template>
<div style="background:#fff">
    <!-- <headerComponent/> -->
    <div class="pageContainer">
        <!-- <carousel :perPage="1" :autoplay="true" :loop="true" style="height:540px">  
            <slide v-for="image in images" :key="image">  
                <img :src="require(`${image}`)" alt="carousel image">  
            </slide>  
        </carousel>   -->
        <img :src="curImg.src" alt="" srcset="" style="width:100%;"  class="animate__animated animate__slideInLeft">

    </div>
    <div class="containerOne" style="position:relative;width:100%;height:820px;margin:45px 0 0 0">
      <div style="width:1300px;margin:0 auto">
        <!-- <img src="@/views/solution/images/group02.png" alt="" srcset="" style="width:100%;padding:30px 0 0px 0;display:block;margin-bottom:60px;"> -->
        <!-- 公共组建开始 -->
        <module-tit title="Contact" subTitle="联系我们" titleStyle="width:365px" subTitleStyle="width:915px"/>
        <!-- 公共组件结束 -->
        <div class="tit">
          <span style="font-size:28px;font-weight:700">{{info.sevice.title}}</span>
          <span style="font-size:16px;letter-spacing:1px">{{info.sevice.content}}</span>
        </div>

        <div class="one" style="float:left;position:relative"  v-animate-onscroll="'animate__animated animate__fadeInLeft'">
          <!-- <img src="@/views/contactUs/images/item01.png" alt="" srcset="" style="width:98%"> -->
          <div id="map" style="width:98%;height:360px;" > </div>
          <div class="footWords">
            <span style="font-size:24px;font-weight:700">{{info.map.one.title}}</span>
            <span style="font-size:14px;display:block;">{{info.map.one.addr}}</span>
            <span style="font-size:14px;display:block">{{info.map.one.phone}}</span>
          </div>
        </div>

        <div class="one" style="float:right;text-align:left;position:relative"  v-animate-onscroll="'animate__animated animate__fadeInRight'">
          <!-- <img src="@/views/contactUs/images/item02.png" alt="" srcset="" style="width:98%"> -->
          <div id="map2" style="width:98%;height:360px;" > </div>
          <div class="footWords" style="">
            <span style="font-size:24px;font-weight:700">{{info.map.two.title}}</span>
            <span style="font-size:14px;display:block">{{info.map.two.addr}}</span>
            <span style="font-size:14px;display:block">{{info.map.two.phone}}</span>
          </div>
        </div>

        <div class="clearBoth"></div>
        
      </div>
    </div>
    <!-- <footerComponent/> -->
</div>
</template>
<script>
// import headerComponent from '@/components/header'
// import footerComponent from '@/components/footer'
// 引入Vue Carousel组件  
// import { Carousel, Slide } from 'vue-carousel'; 
import { cate  } from '@/api/index.js'
import moduleTit from '@/components/moduleTit'
export default {
  name: 'App',
   components:{
    // headerComponent,
    // footerComponent,
    // Carousel,  
    // Slide
    moduleTit
  },
  mounted() {  
    this.$nextTick(()=>{
      this.changeLang()
       this.initMap();  
       this.initMap2();
       this.cateEvent()
    })
   
  }, 
  data() {  
    return {  
      curImg:{},
      info:{
        sevice:{
          title:'客户服务',
          content:'客户满意度对优力美至关重要。如果您对我们的产品、服务或工具有任何疑问或顾虑，请与我们的客户服务团队联系。'
        },
        map: {
          one: {
            title:'研发/运营中心',
            addr:'地址：山东省青岛市城阳区宏祥一路17号天安科创城6号楼',
            phone:'电话：0532-87017699'
          },
          two: {
            title:'生产中心',
            addr:'地址：山东省莱阳市龙门西路214号',
            phone:'电话：0535-7960718'
          }
        }
      }
    };  
  }, 

  methods:{
    cateEvent() {
      cate().then((res)=>{
          this.curImg = this.filterItemsByPath('/#/contactUs',res.data).banner[0]
      })
    },
    filterItemsByPath(path,arr) {
      let _arr = []
      let newArr = []
      _arr = arr
      newArr =  _arr.filter(item => item.path === path);
      if (newArr.length > 0) {
        return newArr[0]; // 只取第一个匹配的对象
      } else {
        return {}; // 如果没有匹配的对象，返回空对象
      }
  },
  changeLang() {
    // const _val = localStorage.getItem('YLMlang')
    // if(_val === 'en') {
    //   this.info = {
    //     sevice:{
    //       title:'Customer service',
    //       content:'Customer satisfaction is very important to Unimax. If you have any questions or concerns about our products, services or tools, please contact our customer service team.'
    //     },
    //     map: {
    //       one: {
    //         title:'R&d/Operations Center',
    //         addr:'Add: No.6 Building, Tianan Kechuang City, No.17 Hongxiang Road, Chengyang District, Qingdao City, Shandong Province',
    //         phone:'Tel: 0532-87017699'
    //       },
    //       two: {
    //         title:'Production center',
    //         addr:'Address: No. 214 Longmen West Road, Laiyang City, Shandong Province',
    //         phone:'Tel: 0535-7960718'
    //       }
    //     }
    //   }
    // } else {
      this.info = {
        sevice:{
          title:'客户服务',
          content:'客户满意度对优力美至关重要。如果您对我们的产品、服务或工具有任何疑问或顾虑，请与我们的客户服务团队联系。'
        },
        map: {
          one: {
            title:'研发/运营中心',
            addr:'地址：山东省青岛市城阳区宏祥一路17号天安科创城6号楼',
            phone:'电话：0532-87017699'
          },
          two: {
            title:'生产中心',
            addr:'地址：山东省莱阳市龙门西路214号',
            phone:'电话：0535-7960718'
          }
        }
      }
    // }
  },
    initMap() {  
      /* eslint-disable */
      var map = new BMap.Map("map"); // 创建Map实例  
      map.centerAndZoom(new BMap.Point(120.246316,36.316754), 14); // 初始化地图,设置中心点坐标和地图级别  
      map.addControl(new BMap.MapTypeControl()); //添加地图类型控件  
      map.setCurrentCity("城阳"); // 设置地图显示的城市 此项是必须设置的  
      map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放  
    },
    initMap2() {  
      /* eslint-disable */
      var map = new BMap.Map("map2"); // 创建Map实例  
      map.centerAndZoom(new BMap.Point(120.64077,36.954096), 14); // 初始化地图,设置中心点坐标和地图级别  
      map.addControl(new BMap.MapTypeControl()); //添加地图类型控件  
      map.setCurrentCity("城阳"); // 设置地图显示的城市 此项是必须设置的  
      map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放  
    }
  }
}
</script>
<style lang="scss" scoped>
.containerOne{
  .one{
    width:50%
  }
}
.footWords{
  padding:20px 0;
  line-height: 30px;
}
.clearBoth {
  clear:both
}
.tit {
  margin:0 0 20px 0;
  span{
    display: block;
    padding:5px 0 10px 0;
  }
}
</style>
